import { render, staticRenderFns } from "./TableviewExtended.vue?vue&type=template&id=5289b68e"
import script from "./TableviewExtended.js?vue&type=script&lang=js&external"
export * from "./TableviewExtended.js?vue&type=script&lang=js&external"
import style0 from "./TableviewExtended.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports